import styled from 'styled-components';
const StyledDiv = styled.div`
    margin-bottom: ${props => props.marginBottom}px;
    display: flex;
    flex-direction: ${props => props.flexDirection};
`;
export default StyledDiv;


// WEBPACK FOOTER //
// ./src/components/FormItem/styles.js